module.exports = __webpack_public_path__ + "img/免@2x.79cd4822.png";